/**
 * 応募フォームのペンネーム上限。
 * プロフィール編集、ペンネーム保存、旧応募フォームはいずれも最大 100 文字で保存する。
 * ここを短くすると、既存の長いペンネームを選んでも Step1 の「次へ」が押せず、理由も出ない。
 */
export const CONTEST_ENTRY_PENNAME_MAX_LENGTH = 100;

/** 応募歴・受賞歴の上限。プロフィール編集・旧応募フォームと同じ 500 文字。 */
export const CONTEST_ENTRY_HISTORY_OF_AWARDS_MAX_LENGTH = 500;
